import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../../core';
import { ArquivoSearch } from '../../arquivo-search';
import { ArquivoBulkUpload } from '../arquivo-bulk-upload';
import { ArquivoUpload } from '../arquivo-upload';

@Injectable({
    providedIn: 'root'
})
export class ArquivoUploadHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/arquivos`;
    }

    /** Realiza o upload de um arquivo */
    upload(upload: ArquivoUpload): Observable<ArquivoSearch> {
        return this.customHttp.post<ArquivoSearch>(this.pathApi, upload);
    }

    /** Realiza o upload de vários arquivos */
    bulkUpload(bulk: ArquivoBulkUpload): Observable<ArquivoSearch[]> {
        return this.customHttp.post<ArquivoSearch[]>(`${this.pathApi}/bulk`, bulk);
    }
}
